import { createFileRoute } from "@tanstack/react-router";
import { LoginPage } from "~/components/orcaloops/LoginDoor.tsx";
import { validateLoginSearch } from "~/lib/login-search.ts";
import { loginDoorHead } from "./index.tsx";

/**
 * Catch-all beneath the orca login door. The door drives Clerk's API itself
 * and never leaves `/login`, but a stale link to one of Clerk's old component
 * steps (`/login/factor-one`, `/login/factor-two`, `/login/verify`, …) still
 * lands here and renders the same door rather than the site 404 (Jeff hit
 * exactly that on orcaloops.ai, 2026-09-06). Ranks below the exact `index.tsx`
 * and the static `sso-callback.tsx`.
 *
 * Only this route matches `/login/<x>`, so it links the frame's sheet itself
 * through the shared {@link loginDoorHead}; the page component is not
 * exported, so it splits into a route chunk.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/orca/login/$")({
  validateSearch: validateLoginSearch,
  head: loginDoorHead,
  component: OrcaLoginCatchAll,
});

function OrcaLoginCatchAll() {
  return <LoginPage />;
}
